module.exports = __webpack_public_path__ + "static/media/folder.7f99f67e.png";